import { render, staticRenderFns } from "./InboxDropdownItem.vue?vue&type=template&id=7ff39da2&scoped=true&"
import script from "./InboxDropdownItem.vue?vue&type=script&lang=js&"
export * from "./InboxDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./InboxDropdownItem.vue?vue&type=style&index=0&id=7ff39da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff39da2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ff39da2')) {
      api.createRecord('7ff39da2', component.options)
    } else {
      api.reload('7ff39da2', component.options)
    }
    module.hot.accept("./InboxDropdownItem.vue?vue&type=template&id=7ff39da2&scoped=true&", function () {
      api.rerender('7ff39da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/InboxDropdownItem.vue"
export default component.exports